/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { KeyPublicType } from './KeyPublicType';

export const KeyPublic: core.serialization.ObjectSchema<serializers.KeyPublic.Raw, Truvity.KeyPublic> =
    core.serialization.object({
        publicKeyBase58: core.serialization.string().optional(),
        publicKeyJwk: core.serialization.string(),
        publicKeyMultibase: core.serialization.string(),
        publicKeyPem: core.serialization.string(),
        type: KeyPublicType,
    });

export declare namespace KeyPublic {
    export interface Raw {
        publicKeyBase58?: string | null;
        publicKeyJwk: string;
        publicKeyMultibase: string;
        publicKeyPem: string;
        type: KeyPublicType.Raw;
    }
}
